

<section class="w-100 text-center delpmtbox">
  <ng-container *ngIf="!isAcmic; else acmicCloseIcon">
    <img src="./assets/img/images/icon-check-circle-mapfre.svg" alt="check circle icon" />
</ng-container>
<ng-template #acmicCloseIcon>
    <img src="./assets/img/images/icon-check-circle-acmic.svg" alt="check circle icon" />
</ng-template>
  <h5 class="delpmtsuccessheader">{{"BANK_ACCOUNT_REMOVED_TEXT" | translate}}</h5>
  <p class="delpmtpara">{{"CHECKING_OR_SAVINGS_ACC" | translate }} <strong>{{ accountNumber }}</strong> was successfully removed. </p>
  
  <p class="mb-0">
      <a routerLink="/my-insurance" class="linkGoToAccount">{{"GO_TO_MY_ACCOUNT" | translate }}</a>
  </p>
</section>
